import { CubeTextureLoader } from 'three'

import { HDRCubeTextureLoader } from 'three/examples/jsm/loaders/HDRCubeTextureLoader'
import { HalfFloatType, TextureLoader } from 'three'

import { lenses } from '@/assets/data'

export class TextureLib {
  constructor () {
    this.promises = []


    this.promises.push(
      new Promise(resolve => {
        this.envMapHdr = new HDRCubeTextureLoader().setDataType(HalfFloatType).setPath( '/textures/cubemaps/3/' ).load([
          'px.hdr',
          'nx.hdr',
          'py.hdr',
          'ny.hdr',
          'pz.hdr',
          'nz.hdr'
        ], resolve)
      }),
      ...this.loadFlares()
    )

    this.promise = Promise.all(this.promises)
  }

  loadFlares () {
    this.texturesFlares = []
    const textureLoader = new TextureLoader().setPath('/textures/flares/')
    const promises = []

    lenses.forEach((lense, index) => {
      promises.push(new Promise(resolve => {
        this.texturesFlares[index] = textureLoader.load(lense.url, resolve)
      }))
    })

    return promises
  }
}

export const textureLib = new TextureLib()